import {
  updateObject
} from 'helpers/ReducerUtil.js'
import Enums from 'helpers/Enums'
import { UPDATE_ASYNC_WAIT_FILTER } from './constants'

const initialState = {}

const updateAsyncFilterCount = (state, action) => {
  let updatedState = state
  // Make sure action even exists inside the list of actions
  const actionKey = action.action
  if (actionKey){
    const prevCount = state[actionKey] || 0
    const updateCount = prevCount + action.count
    updatedState = updateObject(state, { [actionKey]: updateCount })
  } else {
    throw new Error('actionKey does not exist!')
  }
  return updatedState
}

export default function posts(state = initialState, action) {
  switch (action.type) {
  case UPDATE_ASYNC_WAIT_FILTER: return updateAsyncFilterCount(state, action)
  default: return state
  }
}